export default {"src":"/_next/static/media/retaining-walls.849a8daa.svg","height":28,"width":30,"blurWidth":0,"blurHeight":0};